import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { getLoans } from "service/policy/getLoans";
import {
  isOldAlicUlPolicy,
  isPolicyInactiveByPolicyStatus,
} from "js/utilities";
import {
  stringFormattingToCurrency,
  getBadgeText,
  getPoliciesOptions,
} from "js/formatting";
import { useTranslation } from "react-i18next";
import RELEASING_AutoCompleteComboBox from "components/General/AutoCompleteComboBox/RELEASING_AutoCompleteComboBox";
import FormInputError from "components/General/FormInputError";

const PanelOne = ({
  dataArray,
  setCurrentStep,
  selectedPolicy,
  setSelectedPolicy,
  setLoan,
  user,
  setIsLoading,
}) => {
  const { policy_id } = useParams();
  const { t } = useTranslation();
  const [policyFilterOptions, setPolicyFilterOptions] = useState([]);
  const [selectedPolicyId, setSelectedPolicyId] = useState({
    value: "all",
    displayAs: `${t("AutoComplate-select-your-contract")}`,
    selectedPolicyDisplayAs: `${t("AutoComplate-select-your-contract")}`,
  });
  const [inactivePolicyError, setInactivePolicyError] = useState("");

  //GetLoan api call
  const getLoansApi = (policy) => {
    setIsLoading(true);
    setInactivePolicyError("");
    if (isPolicyInactiveByPolicyStatus(policy?.status)) {
      setIsLoading(false);
      setInactivePolicyError("You cannot make a payment on this contract.");
    } else if (isOldAlicUlPolicy(policy)) {
      setCurrentStep(2);
      setIsLoading(false);
    } else {
      getLoans(policy?.contractID)
        .then((res) => {
          if (res?.allProducts?.loanBalance > 0) {
            setLoan(res);
            setCurrentStep(2);
          } else {
            setCurrentStep(3);
          }
          setIsLoading(false);
        })
        .catch((error) => {
          console.error("GetLoan api failing", error);
          setIsLoading(false);
          setCurrentStep(2);
        });
    }
  };

  useEffect(() => {
    if (policy_id) {
      let policy = dataArray?.find((p) => p.contractID === policy_id);
      setSelectedPolicy(policy);
      const policyOption = getPoliciesOptions([policy]);
      setSelectedPolicyId({
        ...policyOption[0],
        selectedPolicyDisplayAs: `${policyOption[0].prodType}: ${policyOption[0].value}`,
      });
      getLoansApi(policy);
    }
  }, [policy_id]);
  // getting policy number with primary owner full name
  useEffect(() => {
    const policySelectionArray = getPoliciesOptions(dataArray);
    let policiesOptions = [];
    policySelectionArray.forEach((policy) => {
      policiesOptions.push({
        ...policy,
        selectedPolicyDisplayAs: `${policy.prodType}: ${policy.value}`,
      });
    });

    setPolicyFilterOptions([selectedPolicyId, ...policiesOptions]);

    if (policiesOptions.length === 1) {
      setSelectedPolicy(dataArray[0]);
      getLoansApi(dataArray[0]);
      setSelectedPolicyId(policiesOptions[0]);
    }
  }, []);

  useEffect(() => {
    if (selectedPolicyId?.value && selectedPolicyId?.value !== "all") {
      let policy = dataArray?.find(
        (p) => p.oldPolicy === selectedPolicyId.value
      );
      setSelectedPolicy(policy);
      getLoansApi(policy);
    } else {
      setCurrentStep(1);
    }
  }, [selectedPolicyId]);

  return (
    <div className="px-0 md:px-16 overflow-visible">
      <div className="rounded border p-2">
        <form>
          <RELEASING_AutoCompleteComboBox
            labelName={t("CustomerMakeAPayment-step-one-contract-number-label")}
            inputPlaceholderText={t(
              "CustomerMakeAPayment-step-one-inputPlaceholderText"
            )}
            options={policyFilterOptions}
            invalidMessage={t("AlertsCorrespondence-input-invalid-msg-1")}
            selectedOption={selectedPolicyId}
            setSelectedOption={setSelectedPolicyId}
            readOnly={policyFilterOptions.length <= 2}
          />
          {selectedPolicy &&
            selectedPolicyId?.value &&
            selectedPolicyId?.value !== "all" && (
              <div className="flex justify pt-2">
                <svg
                  className={`ui-icon w-3 h-3 mr-2 self-center text-ui-${
                    getBadgeText(selectedPolicy).includes("Past due")
                      ? "red"
                      : "green"
                  }`}
                  focusable="false"
                  aria-hidden="true"
                  role="presentation"
                >
                  <use href="#ui-icon-circle-solid-exclamation"></use>
                </svg>
                <p className="self-center font-semibold">
                  {getBadgeText(selectedPolicy).includes("Past due")
                    ? "Past due "
                    : "Paid to date "}
                  {stringFormattingToCurrency(
                    selectedPolicy?.modalPremiumAmountTotal
                  )}
                </p>
              </div>
            )}
          {inactivePolicyError && (
            <FormInputError errorMessage={inactivePolicyError} />
          )}
        </form>
      </div>
    </div>
  );
};

export default PanelOne;
